import React from 'react';
import Styles from './CDCProtegido25Informacoes.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function CDCProtegido25Informacoes() {
  return (
    <>
      <section id="cdc-informacoes">
        <ContainerHome24>
          <div className="informacoes-contain-1">
            <div className="informacoes-contain-1-textos">
              <h2 className="informacoes-contain-1-titulo">
                Informações sobre o seu Seguro Prestamista - Bens e Serviços
              </h2>
              <p className="informacoes-contain-1-texto">
                Informações válidas somente para clientes que aderiram ao Seguro Prestamista após o
                dia 01/01/2022. Ver condições:
              </p>
            </div>
            <div className="informacoes-contain-1-docs">
              <div>
                <a
                  href="pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista v4.pdf"
                  target="_blank"
                  className="informacoes-contain-1-doc"
                >
                  <img src="assets/cdc25/ic_file_pdf.svg" alt="" />
                  <p className="informacoes-contain-1-doc-titulo">Condições Gerais do Seguro</p>
                </a>
                <a
                  href="pdf/protegido/Manual_Assistencia_CDC_Bens_V4.pdf"
                  target="_blank"
                  className="informacoes-contain-1-doc"
                >
                  <img src="assets/cdc25/ic_file_pdf.svg" alt="" />
                  <p className="informacoes-contain-1-doc-titulo">Manual de Assistência</p>
                </a>
              </div>
              <div>
                <a
                  href="pdf/protegido/Regulamento_CAP_CDC_Outros_Bens.pdf"
                  target="_blank"
                  className="informacoes-contain-1-doc"
                >
                  <img src="assets/cdc25/ic_file_pdf.svg" alt="" />
                  <p className="informacoes-contain-1-doc-titulo">Regras da Capitalização</p>
                </a>
                <a
                  href="https://www.santander.com.br/portal/wps/script/templates/GCMRequest.do?page=5495"
                  target="_blank"
                  className="informacoes-contain-1-doc"
                >
                  <img src="assets/cdc25/ic_file_pdf.svg" alt="" />
                  <p className="informacoes-contain-1-doc-titulo">Consulte seu número da sorte</p>
                </a>
              </div>
            </div>
          </div>
          <div className="informacoes-contain-2">
            <img src="assets/cdc25/bens.png" alt="" className="img-informacoes" />
            <div className="informacoes-contain-2-docs">
              <h3 className="informacoes-contain-2-titulo">Conheça nossas condições contratuais</h3>
              <a
                href="pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista v4.pdf"
                target="_blank"
                className="informacoes-contain-2-doc"
              >
                <img src="assets/cdc25/ic_file_pdf.svg" alt="" />
                <div className="informacoes-contain-2-doc-textos">
                  <p className="informacoes-contain-2-doc-titulo">
                    Condições Contratuais: Proteção Financeira
                  </p>
                  <p className="informacoes-contain-2-doc-vigencia">
                    Vigência: de 01/01/2019 até 31/12/2021
                  </p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <section id="seguro-prestamista-cdc">
        <ContainerHome24>
          <p className="seguro-prestamista-cdc-texto">
            Seguro Prestamista Santander CDC Protegido com Desemprego, CDC Protegido Moto com
            Desemprego, CDC Protegido Valor Total e CDC Protegido Valor com Desemprego são
            garantidos por Zurich Santander Brasil Seguros e Previdência S.A., CNPJ
            87.376.109/0001-06, Registro Susep 0507-0, Processo SUSEP 15414.901791/2019-11. O
            segurado poderá consultar a situação cadastral de sua corretora Santander S.A. -
            Serviços Técnicos, Administrativos e de Corretagem de Seguros, no site www.susep.gov.br,
            na SUSEP não implica, por parte da Autarquia, incentivo ou recomendação a sua
            comercialização. Consulte previamente as condições gerais disponíveis nas agências ou no
            site www.santanderfinanciamentos.com.br - informações importantes - condições Gerais CDC
            Protegido. Canal Ouvidoria 0800 726 0322.
            <br />
            Banco Santander (Brasil) S.A., SANTANDER SOCIEDADE DE CRÉDITO, FINANCIAMENTO E
            INVESTIMENTO S.A., e Santander Corretora de Seguros, Investimentos e Serviços S.A.
            possuem acordo de exclusividade com Zurich Santander Brasil Seguros e Previdência S.A. e
            Zurich Santander Brasil Seguros S.A. para a distribuição de produtos de seguros.
            Santander Corretora de Seguros, Investimentos e Serviços S.A. é uma sociedade do Grupo
            Santander Brasil, cujo controle é detido integralmente pelo Banco Santander (Brasil)
            S.A.
          </p>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CDCProtegido25Informacoes;
